import { render, staticRenderFns } from "./PropInteractionsTotal.vue?vue&type=template&id=dbe0a5b8&"
import script from "./PropInteractionsTotal.vue?vue&type=script&lang=js&"
export * from "./PropInteractionsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports